import { $$ } from "./../OO_jquery";
import { getOrders } from "../../api/services/userService.js";
import { getStore } from "../../api/services/storeService.js";
import { cancelOrder } from "../../api/services/orderService.js";
import { mapGetters, mapMutations, mapActions } from "vuex";
import { DateTime } from "luxon";
import {
  IsStoreOpenAtTime,
  getCurrentDate,
} from "./../../api/helpers/datetimeHelper.js";
import { getOrderStatus } from "../../api/helpers/orderHelper";
export default {
  computed: {
    ...mapGetters([
      "user",
      "selectedCompany",
      "currencySign",
    ]),
    taxLabel() {
      let locale = this.selectedCompany 
        ? this.selectedCompany.CurrencyLocaleName
        : null;
      locale = typeof locale === 'string' ? locale.toLowerCase() : locale;
      return locale === 'id-id' ? this.$t('message.tax') : this.$t('message.gst');
    },
    IsStoreClose() {
      var now = getCurrentDate(this.currentStoreDoc.TimezoneIanaFormat);
      return (
        (!IsStoreOpenAtTime(
          this.currentStoreDoc.BlackoutDates,
          this.currentStoreDoc.OperatingHours,
          this.currentStoreDoc.IsInOperation,
          now
        ) &&
          !(
            this.currentStoreDoc.EnablePreoderForDelivery ||
            this.currentStoreDoc.EnablePreoderForPickup
          )) ||
        !this.currentStoreDoc.IsInOperation
      );
    },
    chargesAdminFee() {
      return this.currentStoreDoc.CancellationTermsAndConditions || false;
    },
    adminFeeMessage() {
      return this.currentStoreDoc.CancellationTermsAndConditions;
    }
  },
  methods: {
    ...mapActions(["insertErrorlog", "redirectToErrorPage"]),
    ...mapMutations(["setStoreLoaded"]),
    enableCancellation(item) {
      if (
        this.currentStoreDoc.OrderCancellation &&
        this.currentStoreDoc.OrderCancellation.OrderCancellationAllowed
      ) {
        var jsDate = new Date(item.ScheduledTime.seconds * 1000);
        var scheduledTime = DateTime.fromJSDate(jsDate, {zone: this.currentStoreDoc.TimezoneIanaFormat});
        var lastUpdateTime = scheduledTime.minus({
          minute: this.currentStoreDoc.OrderCancellation
            .CancellationTimeBufferInMinutes,
        });
        var now = getCurrentDate(this.currentStoreDoc.TimezoneIanaFormat);
        return (
          lastUpdateTime > now &&
          [2, 4].some((s) => s == item.OnlineOrderStatus)
        );
      }
      return false;
    },
    cancelOrder() {
      var that = this;
      this.progressing = true;
      var jsDate = new Date(
        this.selectedOrder.ScheduledTime.seconds * 1000
      ).toUTCString();
      cancelOrder(this.selectedOrder, jsDate).then((response) => {
        that.progressing = false;
        that.$refs.cancelConfirm.hideModal();
        that.closeCancelConfirm();
        if (response.data.Success) that.initOrders(that.selectedOrder.StoreID);
      });
    },
    showActiveOrderLink(order) {
      if (getOrderStatus(order) == 1) {
        return true;
      }
      return false;
    },
    parseDate(value, store, orderNumber) {
      if (value) {
        let mm = DateTime.fromJSDate(new Date(value.seconds * 1000));
        return `#${orderNumber} on ${mm.toFormat("ccc dd MMM")} <span>${
            this.$t("message.at")
          }</span> ${mm.toFormat("h:mm a")} <span>${
            this.$t("message.fromName")
          }</span> ${store}`;
      } else {
        return `#${orderNumber} <span>${this.$t("message.fromName")}</span> ${
            store
          }`;
      }
    },
    formatPagination() {
      this.$nextTick(() => {
        $$(".VuePagination__pagination-item-prev-page a").text(
          this.$t("message.previous")
        );
        $$(".VuePagination__pagination-item-next-page a").text(
          this.$t("message.next")
        );
      });
    },
    initOrders(storeid) {
      var that = this;
      getOrders(this.user.id, storeid)
        .onSnapshot(
          (collection) => {
            if (!collection.empty) {
              that.records = collection.size;
              that.formatPagination();
              that.orders.splice(0, that.orders.length);
              const history = [];
              collection.forEach(doc => {
                history.push(doc.data());
              });
              history.sort(function(a, b) {
                return a.CreatedOn.seconds < b.CreatedOn.seconds
                  ? 1
                  : b.CreatedOn.seconds < a.CreatedOn.seconds
                  ? -1
                  : 0;
              });
              that.orders = history;
              
              that.pageOrders.splice(0, that.pageOrders.length);
              for (
                let index = 0;
                index <
                (that.perPage < that.orders.length
                  ? that.perPage
                  : that.orders.length);
                index++
              ) {
                const element = that.orders[index];
                that.pageOrders.push(element);
              }
            }
          },
          function(reason) {
            that.insertErrorlog([
              reason.code,
              reason.message,
              that.$router.currentRoute.fullPath,
            ]);
            that.redirectToErrorPage();
          }
        );
    },
    paginateCallback(pageNumber) {
      this.pageOrders = [];
      let start = (pageNumber - 1) * this.perPage;
      let end = start + this.perPage;
      while (end > this.orders.length) {
        end--;
      }
      for (let index = start; index < end; index++) {
        const element = this.orders[index];
        this.pageOrders.push(element);
      }
    },
    moreCallback() {
      let start = (this.page - 1) * this.perPage;
      let end = start + this.perPage;
      while (end > this.orders.length) {
        end--;
      }
      for (let index = start; index < end; index++) {
        const element = this.orders[index];
        this.pageOrders.push(element);
      }
      this.page++;
    },
    showComplateOrderPage(order) {
      this.$router.push({
        name: "completeorder",
        params: { storeid: order.StoreID, orderid: order.UDID },
      });
    },
    closeConfirm() {
      this.showConfirm = false;
    },
    closeCancelConfirm() {
      this.showCancelConfirm = false;
    },
    showReorderConfirm(order) {
      this.selectedOrder = order;
      this.showConfirm = true;
    },
    showCancelConfirmDialog(order) {
      
      var jsDate = new Date(order.ScheduledTime.seconds * 1000);
      var scheduledTime = DateTime.fromJSDate(jsDate, { zone: this.currentStoreDoc.TimezoneIanaFormat });
      var lastUpdateTime = scheduledTime.minus({
        minute: this.currentStoreDoc.OrderCancellation
          .CancellationTimeBufferInMinutes,
      });
      var now = getCurrentDate(this.currentStoreDoc.TimezoneIanaFormat);
      if (lastUpdateTime > now) {
        this.selectedOrder = order;
        this.showCancelConfirm = true;
      } else {
        this.showmeesage = true;
        var that = this;
        setTimeout(function () { that.showmeesage = false; }, 4000);
        this.$forceUpdate();
      }
    },
    async reorder() {
      let store = null;
      if (this.selectedOrder.StoreID !== this.$route.params.storeid) {
        store = await getStore(this.selectedOrder.StoreID).get();
        if (store.exists) {
          store = store.data();
          var now = getCurrentDate(store.TimezoneIanaFormat);
          var closed =
            (!IsStoreOpenAtTime(
              store.BlackoutDates,
              store.OperatingHours,
              store.IsInOperation,
              now
            ) &&
              !(
                store.EnablePreoderForDelivery || store.EnablePreoderForPickup
              )) ||
            !store.IsInOperation;
          if (closed) {
            alert(
              store.ClosingStoreMessage
                ? store.ClosingStoreMessage
                : this.$t("message.CurrentlyNotTakingOnlineOrders")
            );
            return false;
          }
        } else {
          alert(this.$t("StoreNotFound"));
          return false;
        }
      } else if (this.IsStoreClose) {
        alert(
          this.currentStoreDoc.ClosingStoreMessage
            ? this.currentStoreDoc.ClosingStoreMessage
            : this.$t("message.CurrentlyNotTakingOnlineOrders")
        );
        return false;
      }
      this.loading = true;
      this.error = "";
      this.$router.push({
        name: "checkout",
        params: {
          storeid: store == null ? this.$route.params.storeid : store.ID,
          storename: store == null ? this.$route.params.storename : store.Name,
          orderid: this.selectedOrder.UDID,
        },
      });
      this.$refs.reorderConfirm.hideModal();
    },
  },
};
